import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { map } from 'rxjs/operators';
import { CustomItemVerticalTwoAndThreeSelectionData } from './custom-item-vertical-two-and-three-selection.model';

@Component({
  selector: 'app-custom-item-vertical-two-and-three-selection',
  templateUrl: './custom-item-vertical-two-and-three-selection.component.html',
  styleUrls: ['./custom-item-vertical-two-and-three-selection.component.scss'],
  standalone: false
})
export class CustomItemVerticalTwoAndThreeSelectionComponent implements OnInit {
  @Input() item: CustomItemVerticalTwoAndThreeSelectionData;
  @HostBinding('class') styleClasses: string;

  constructor(public component: CmsComponentData<CustomItemVerticalTwoAndThreeSelectionData>) { }

  data$ = this.component.data$.pipe(map(component => component));

  ngOnInit(): void {
  }

}
